import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { Box, xcss } from '@atlaskit/primitives';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';

import { messages as commonMessages } from '../../../../common/messages';
import { DateNavigation } from '../../../../common/ui/date-navigation';
import { useActions as usePageActions } from '../../../../controllers/page-store';
import { useStore as useScheduleStore } from '../../../../controllers/schedule-store';
import {
	useTimelineEpoch,
	useTimelineLoading,
} from '../../../../controllers/schedule-store/helpers';

import { messages } from './messages';
import { Container } from './styled';

const buttonContainerStyles = xcss({
	marginInlineStart: 'space.100',
	marginInlineEnd: 'auto',
});

const Controls = () => {
	const intlApi = useIntl();
	const [
		{ timelineType, selectedView, schedule },
		{
			setTimelineTypeAction,
			setSelectedViewAction,
			previousPeriodAction,
			nextPeriodAction,
			todayAction,
		},
	] = useScheduleStore();
	const [{ startEpoch, endEpoch, nowEpoch, startOffset, endOffset, nowOffset }] =
		useTimelineEpoch();
	const [{ isLoading: isTimelineLoading }] = useTimelineLoading();
	const { openTakeOnCall, openAddOverride } = usePageActions();

	return (
		<Container>
			<Button
				id={`${schedule.id}-add-override`}
				isLoading={isTimelineLoading}
				aria-label={intlApi.formatMessage(messages.addOverrideFor, {
					scheduleName: schedule.name,
				})}
				onClick={(_, analyticsEvent) => {
					fireUIAnalytics(analyticsEvent, 'addOverride');

					openAddOverride({ schedule, id: `${schedule.id}-add-override` });
				}}
			>
				{intlApi.formatMessage(commonMessages.addOverride)}
			</Button>

			<Box xcss={buttonContainerStyles}>
				<Button
					id={`${schedule.id}-take-on-call`}
					aria-label={intlApi.formatMessage(messages.takeOnCallFor, {
						scheduleName: schedule.name,
					})}
					onClick={(_, analyticsEvent) => {
						fireUIAnalytics(analyticsEvent, 'takeOnCall');

						openTakeOnCall({ schedule, id: `${schedule.id}-take-on-call` });
					}}
				>
					{intlApi.formatMessage(messages.takeOnCall)}
				</Button>
			</Box>

			<DateNavigation
				endEpoch={endEpoch}
				isLoading={isTimelineLoading}
				nextPeriod={nextPeriodAction}
				nowEpoch={nowEpoch}
				onTimelineTypeChange={setTimelineTypeAction}
				onToday={todayAction}
				onViewChange={setSelectedViewAction}
				previousPeriod={previousPeriodAction}
				selectedTimelineType={timelineType}
				selectedView={selectedView}
				startEpoch={startEpoch}
				startOffset={startOffset}
				endOffset={endOffset}
				nowOffset={nowOffset}
				scheduleName={schedule.name}
			/>
		</Container>
	);
};

export { Controls };
